// Contact / CTA helpers built from site settings.

export function digitsOnly(s = "") {
  return (s || "").replace(/[^0-9]/g, "");
}

export function whatsappLink(settings, message) {
  const num = digitsOnly(settings?.whatsapp || settings?.phone_intl || "905392317495");
  const text = encodeURIComponent(message || settings?.whatsapp_default_message || "Merhaba, bilgi almak istiyorum.");
  return `https://wa.me/${num}?text=${text}`;
}

export function telLink(settings) {
  const num = settings?.phone_intl || "+905392317495";
  return `tel:${num}`;
}

export function mapsLink(settings) {
  return settings?.maps_link || "https://maps.app.goo.gl/vCW6ED1ZBUfVfM3H6";
}

export function serviceWhatsAppMessage(serviceName, district) {
  if (district) {
    return `Merhaba, ${district} bölgesinde ${serviceName} hizmetiniz hakkında bilgi almak istiyorum. Aracım: …`;
  }
  return `Merhaba, ${serviceName} hizmetiniz hakkında bilgi almak istiyorum. Aracım: …`;
}
